import { AnyAction } from '@reduxjs/toolkit';

const actionTypeFulfilledGuard = (action: AnyAction) =>
  action.type.endsWith('/fulfilled');

export default actionTypeFulfilledGuard;
